import teletherapyImg from "src/assets/icons/icon-teletherapy.svg";
import inPersonImg from "src/assets/icons/icon-inPerson.svg";
import { MeetingTypeEnum } from "src/latest/src/constants/MeetingTypeEnums";
import { Typography } from "src/latest/src/components";

type Props = {
    section: any;
};

export function MeetingPreferences({ section }: Props) {

    return (
        <>
            {section &&
                section?.questions?.map((question: any) => {
                    return (
                        <>
                            {question?.choices?.map(
                                (choice: any, index: number) => {
                                    const uniquekey = choice.unique_key;

                                    if (choice?.selected) {
                                        const isMultiple =
                                        uniquekey === MeetingTypeEnum.EITHER_TELETHERAPY_OR_IN_PERSON_SESSIONS;
                                            
                                        // const metaData = stringToObject(choice.metadata);
                                        let singleImage = {
                                            img: "",
                                            imgBG: "",
                                        };

                                        if (uniquekey === MeetingTypeEnum.ONLY_ONLINE) {
                                            singleImage = {
                                                img: teletherapyImg,
                                                imgBG: "mf-tele",
                                            };
                                        } else if (uniquekey === MeetingTypeEnum.ONLY_IN_PERSON) {
                                            singleImage = {
                                                img: inPersonImg,
                                                imgBG: "mf-in-person",
                                            };
                                        }

                                        const singleImgClass =
                                            "therapist-profile__meeting-pref mf " +
                                            singleImage.imgBG;

                                        return (
                                            <div
                                                key={
                                                    "meetingpreference-" + index
                                                }
                                                className="therapist-profile__meeting-pref-wrap d-flex flex-column mt-3"
                                            >
                                                {isMultiple ? (
                                                    <div className="multiple-meet-pref ps-3">
                                                        <label className="therapist-profile__meeting-pref mf mf-tele ">
                                                            <img
                                                                src={
                                                                    teletherapyImg
                                                                }
                                                                alt="Teletherapy"
                                                            />
                                                        </label>
                                                        <label className="therapist-profile__meeting-pref mf mf-in-person">
                                                            <img
                                                                src={
                                                                    inPersonImg
                                                                }
                                                                alt="In Person"
                                                            />
                                                        </label>
                                                    </div>
                                                ) : (
                                                    <div className="single-meet-pref ps-3">
                                                    <label
                                                        className={
                                                            singleImgClass
                                                        }
                                                    >
                                                        <img
                                                            src={
                                                                singleImage?.img
                                                            }
                                                            alt=""
                                                        />
                                                    </label>
                                                    </div>
                                                )}

                                                <Typography
                                                    variant="size-16"
                                                    weight="normal"
                                                    color="color-2"
                                                    className="d-inline-block meet-pref-text mt-3"
                                                >
                                                    {choice?.display_title}
                                                </Typography>
                                            </div>
                                        );
                                    } else {
                                        return <></>;
                                    }
                                }
                            )}
                        </>
                    );
                })}
        </>
    );
}
